import moment from "moment";
import { PasswordRecoveryAPI } from "../api";

export class PasswordRecovery {
  constructor(props) {
    this.id = props.objectId || "";
    this.objectId = props.objectId || "";
    this.user = props.user
  }
  static async createPasswordRecovery(payload) {
    const { data } = await PasswordRecoveryAPI.createPasswordRecovery(payload);
    // data.result = new PasswordRecovery(data.result);
    return data.result;
  }
  static async checkPasswordRecovery(payload) {
    const { data } = await PasswordRecoveryAPI.checkPasswordRecovery(payload);
    // data.result = new PasswordRecovery(data.result);
    return data.result;
  }
  static async changePasswordRecovery(payload) {
    const { data } = await PasswordRecoveryAPI.changePasswordRecovery(payload);
    // data.result = new PasswordRecovery(data.result);
    return data.result;
  }
  static async getPasswordRecovery(payload) {
    const { data } = await PasswordRecoveryAPI.getPasswordRecovery(payload);
    data.result = new PasswordRecovery(data.result);
    return data.result;
  }
}
